import React from 'react';
import PropTypes from 'prop-types';

const Spyglass = ({ color, overRideStylesMag }) => {
  return (
    <svg
      className={['magnifying-glass-icon', overRideStylesMag].join(' ')}
      xmlns="http://www.w3.org/2000/svg"
      height="19px"
      width="19px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>Magnifying Glass</title>
      <path
        fill={color}
        id="Path_535"
        className="st0"
        d="M990.29,938.92L990.29,938.92L749.97,697.65l8.91-11.45C902.6,501.54,869.71,235.39,685.36,91.27
        L684.99,91C500.33-52.73,234.18-19.85,90.05,164.48v0.26C-53.94,349.28-21.09,615.6,163.42,759.63l0,0l0.42,0.26
        c74.68,58.03,166.53,89.57,261.1,89.67H427c95.33-0.7,187.67-33.39,262.21-92.84l11.55-9.23l240.05,241.21
        c13.65,13.6,35.74,13.57,49.35-0.08c13.6-13.65,13.57-35.74-0.08-49.35L990.29,938.92z M675.55,674.86
        c-66.08,66.7-156.03,104.27-249.92,104.39h-1.11C228.64,779.54,69.61,620.99,69.32,425.1S227.58,70.19,423.46,69.9h0.74
        c195.22,0.4,353.57,158.19,354.67,353.41v1C779.2,518.26,742,608.45,675.55,674.86z"
      />
    </svg>
  );
};

export default Spyglass;

Spyglass.propTypes = {
  color: PropTypes.string.isRequired,
};
